import './App.css';
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";

import {library} from '@fortawesome/fontawesome-svg-core';
import {fab} from '@fortawesome/free-brands-svg-icons';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {far} from '@fortawesome/free-regular-svg-icons';

import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ApiProvider from "./contexts/ApiProvider";
import UserProvider from "./contexts/UserProvider";
import PublicRoute from "./components/PublicRoute";
import PrivateRoute from "./components/PrivateRoute";
// import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import TopNavigationBar from "./components/TopNavigationBar";
import CurrencySettingsPage from "./pages/CurrencySettingsPage";
import IncomeTypeSettingsPage from "./pages/IncomeTypeSettingsPage";
import CostTypeSettingsPage from "./pages/CostTypeSettingsPage";
import IncomeCategorySettingsPage from "./pages/IncomeCategorySettingsPage";
import CostCategorySettingsPage from "./pages/CostCategorySettingsPage";
import AccountProfilePage from "./pages/AccountProfilePage";
import AccountSecurityPage from "./pages/AccountSecurityPage";
import IncomesPage from "./pages/IncomesPage";
import CostsPage from "./pages/CostsPage";
import SidebarStateProvider from "./contexts/SidebarStateProvider";
import DateRangeProvider from "./contexts/DateRangeProvider";
import QuarterlyReportPage from "./pages/QuarterlyReportPage";
import ComparativeReportPage from "./pages/ComparativeReportPage";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  RadialLinearScale,
  Tooltip
} from 'chart.js';

ChartJS.register(
  ArcElement,
  Legend,
  Tooltip,
  PointElement,
  LineElement,
  LinearScale,
  CategoryScale,
  Filler,
  BarElement,
  RadialLinearScale
);

function App() {
  return (
    <>
      <BrowserRouter>
        <ApiProvider>
          <UserProvider>
            <DateRangeProvider>
              <SidebarStateProvider>
                <TopNavigationBar/>
                <Routes>
                  <Route path="/login" element={
                    <PublicRoute>
                      <LoginPage/>
                    </PublicRoute>
                  }/>
                  {/*<Route path="/register" element={*/}
                  {/*  <PublicRoute>*/}
                  {/*    <RegisterPage/>*/}
                  {/*  </PublicRoute>*/}
                  {/*}/>*/}
                  <Route path="/forgot-password" element={
                    <PublicRoute>
                      <ForgotPasswordPage/>
                    </PublicRoute>
                  }/>
                  <Route path="/reset-password" element={
                    <PublicRoute>
                      <ResetPasswordPage/>
                    </PublicRoute>
                  }/>
                  <Route path="*" element={
                    <PrivateRoute>
                      <Routes>
                        <Route path="/"
                               element={<DashboardPage/>}/>
                        <Route path="/dashboard"
                               element={<DashboardPage/>}/>
                        <Route path="/incomes"
                               element={<IncomesPage/>}/>
                        <Route path="/costs"
                               element={<CostsPage/>}/>
                        <Route path="/reports/quarterly-report"
                               element={<QuarterlyReportPage/>}/>
                        <Route path="/reports/comparative-report"
                               element={<ComparativeReportPage/>}/>
                        <Route path="/settings/currency"
                               element={<CurrencySettingsPage/>}/>
                        <Route path="/settings/income-type"
                               element={<IncomeTypeSettingsPage/>}/>
                        <Route path="/settings/income-category"
                               element={<IncomeCategorySettingsPage/>}/>
                        <Route path="/settings/cost-type"
                               element={<CostTypeSettingsPage/>}/>
                        <Route path="/settings/cost-category"
                               element={<CostCategorySettingsPage/>}/>
                        <Route path="/account-profile"
                               element={<AccountProfilePage/>}/>
                        <Route path="/account-security"
                               element={<AccountSecurityPage/>}/>
                        <Route path="*" element={<Navigate to="/incomes"/>}/>
                      </Routes>
                    </PrivateRoute>
                  }/>
                </Routes>
              </SidebarStateProvider>
            </DateRangeProvider>
          </UserProvider>
        </ApiProvider>
      </BrowserRouter>
    </>
  );
}

export default App;

library.add(fab, fas, far)
